var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z",
    fill: "#E86247"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67489 3.68197C9.87015 3.48671 10.1867 3.48671 10.382 3.68197C10.5773 3.87723 10.5773 4.19381 10.382 4.38908C10.382 4.38908 8.67078 6.3287 7.5 7.5C6.32239 8.67813 4.37159 10.3995 4.37159 10.3995C4.17633 10.5947 3.85974 10.5947 3.66448 10.3995C3.46922 10.2042 3.46922 9.88764 3.66448 9.69238C3.66448 9.69238 5.32051 7.67867 6.5 6.5C7.67267 5.32814 9.67489 3.68197 9.67489 3.68197Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2052 9.5156C10.4005 9.71086 10.4005 10.0274 10.2052 10.2227C10.01 10.418 9.69338 10.418 9.49811 10.2227C9.49811 10.2227 7.61712 8.61958 6.5 7.5C5.4078 6.4054 3.84126 4.56585 3.84126 4.56585C3.646 4.37059 3.646 4.05401 3.84126 3.85875C4.03652 3.66348 4.3531 3.66348 4.54837 3.85875C4.54837 3.85875 6.40489 5.40759 7.5 6.5C8.62009 7.61732 10.2052 9.5156 10.2052 9.5156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default __webpack_public_path__ + "static/media/errors.662512a359ce41bce4524e90eee3334e.svg";
export { ForwardRef as ReactComponent };